import React from 'react';
import { Sparkles } from 'lucide-react';

export default function Header() {
  return (
    <header className="bg-gradient-to-r from-tumbler-blue to-tumbler-blue-light text-white py-8 sm:py-12 md:py-16 px-4 shadow-lg" role="banner">
      <div className="max-w-4xl mx-auto text-center">
        <div className="flex items-center justify-center gap-2 sm:gap-3 mb-3 sm:mb-4">
          <Sparkles className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10" aria-hidden="true" />
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold">Tromluj!</h1>
          <Sparkles className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10" aria-hidden="true" />
        </div>
        <p className="text-base sm:text-lg md:text-xl text-blue-50 mb-2">
          Půjčovna rotační tromlovačky v Brně
        </p>
        <p className="text-sm sm:text-base md:text-lg text-blue-100">
          Půjčení tromlovačky pro hobby tromlování kamenů a minerálů
        </p>
      </div>
    </header>
  );
}
